import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography, Link } from '@mui/material';
import { CreateUser } from './CreateUser';
import { useUser } from './hooks';
import { UserTable } from './UserTable';
import { t } from 'i18next';
import { UserItem } from './UserItem';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { theme } from '@store';
import { ArrowBack } from '@mui/icons-material';

export const User = () => {
  const {
    totalCount,
    entries = [],
    isLoading,
    handleCloseDrawer,
    handleOpenUserDetails,
    isDrawerOpen,
    selectedUserId,
    isInitialFilters,
  } = useUser();

  return (
    <>
      <Box
        sx={{
          cursor: 'pointer',
          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
          width: 'fit-content',
        }}
      >
        <Link
          href={'/admin'}
          underline='always'
          sx={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <ArrowBackIcon sx={{ fontSize: '1.5rem' }} color='primary' />
          <Typography sx={{ color: 'primary' }}>
            {t('general.backToPrevious')}
          </Typography>
        </Link>
      </Box>
      <Box
        sx={{
          paddingTop: '1rem',
          gap: '1rem',
          display: 'flex',
          flexDirection: 'column',
          pb: '1rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box
              sx={{
                cursor: 'pointer',
                [theme.breakpoints.up('md')]: {
                  display: 'none',
                },
                width: 'fit-content',
              }}
            >
              <Link
                href={'/admin'}
                underline='always'
                sx={{
                  gap: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                }}
              >
                <ArrowBack
                  sx={{ fontSize: '2rem', color: 'rgba(0, 0, 0, 0.56)' }}
                  color='primary'
                />
              </Link>
            </Box>
            <Typography variant='h4'>{t('adminPanel.users.title')}</Typography>
          </Box>
          <CreateUser handleOpenUserDetails={handleOpenUserDetails} />
        </Box>
      </Box>
      {entries.length === 0 && isInitialFilters && !isLoading ? (
        <Box
          sx={{
            height: 'calc(100vh - 310px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <AssignmentIndIcon
            sx={{ width: 56, height: 56, mb: 2 }}
            color='primary'
          />
          <Typography variant='h6'>
            {t('adminPanel.users.noResults.title')}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.disabled' }}>
            {t('adminPanel.users.noResults.subTitle')}
          </Typography>
        </Box>
      ) : (
        <UserTable
          rows={entries}
          totalCount={totalCount}
          onSelectUser={handleOpenUserDetails}
          loading={isLoading}
          selectedRowId={selectedUserId}
        />
      )}
      {selectedUserId && (
        <UserItem
          open={isDrawerOpen}
          itemId={selectedUserId}
          handleClose={handleCloseDrawer}
        />
      )}
    </>
  );
};
